
import { useState } from "react";
import LExpandedPlayer from "./LExpandedPlayer";
import LColapsedPlayer from "./LColapsedPlayer";

import "./LSlidingPlayer.css";
import usePlayerControls from "../../hooks/usePlayerControls";

export default function LSlidingPlayer() {
  const {
    playerRef,
    listRef,
    handleParentTap,
    wrapChildClick,
    togglePlay,
  } = usePlayerControls({});

  const [expanded, setExpanded] = useState(false);

  const onTabChevron = () => {
    setExpanded(expanded ? false : true);
  }

  return (
    <div
      ref={playerRef}
      className="l-sliding-player"
      onClick={handleParentTap}
    >
      {expanded && <LExpandedPlayer
        wrapChildClick={wrapChildClick}
        listRef={listRef}
        onTabChevron={onTabChevron}
        expanded={expanded}
      />}
      <LColapsedPlayer
        wrapChildClick={wrapChildClick}
        togglePlay={togglePlay}
        onTabChevron={onTabChevron}
        expanded={expanded}
      />
    </div>
  );
}
